// extracted by mini-css-extract-plugin
export var numbers = "numbers-module--numbers--HhC-U";
export var number = "numbers-module--number--KCuZc";
export var one = "numbers-module--one--PEyyH";